import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";

// project-imports
import Drawer from "./Drawer";
import Header from "./Header";
import Loader from "components/Loader";
import { useSelector } from "react-redux";

import { DRAWER_WIDTH, MenuOrientation, HEADER_HEIGHT } from "config";
import useConfig from "hooks/useConfig";
import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import RouteGuard from "routes/RouteGuard";

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {
  const theme = useTheme();
  useSelector((state) => state.auth.user);
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery(theme.breakpoints.down("xl"));
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  const { container, miniDrawer, menuOrientation } = useConfig();
  const { pathname } = useLocation();
  const mainRef = useRef(null);

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  useEffect(() => {
    if (mainRef.current) mainRef.current.scrollTo(0, 0);
  }, [pathname]);

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!downXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    // <AuthGuard>
    <RouteGuard>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          bgcolor: "white",
          overflow: "hidden",
        }}
      >
        <Header />
        <Drawer />
        {/* {!isHorizontal ? <Drawer /> : <HorizontalBar />} */}

        <Box
          ref={mainRef}
          component="main"
          sx={{
            width: `calc(100% - ${DRAWER_WIDTH}px)`,
            flexGrow: 1,
            py: 5,
            px: { md: 3 },
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <Toolbar
            sx={{
              mt: isHorizontal ? 8 : "inherit",
              mb: isHorizontal ? 2 : "inherit",
              minHeight: `${HEADER_HEIGHT}px !important`, // Ensure proper spacing for header
            }}
          />
          <Container
            maxWidth={container ? "xl" : false}
            sx={{
              xs: 0,
              ...(container && { px: { xs: 0, md: 2 } }),
              position: "relative",
              minHeight: "calc(100vh - 110px)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* {showBreadcrumbs && <Breadcrumbs />} */}
            <Outlet />
          </Container>
        </Box>

        {/* Unverified user alert - top center notification */}
        {/* <UnverifiedAlert /> */}
      </Box>
    </RouteGuard>

    // </AuthGuard>
  );
}
